import React, { useState, useRef, useEffect, useContext } from 'react';
import { FaBars, FaTimes, FaUser } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { links } from '../../utils/data';
import './Navbar.css';
import useWindowSize from '../../utils/useWidowSize';
import Store from '../../utils/Store';

const Navbar = () => {
	const { user, logout } = useContext(Store);
	const history = useHistory();

	const { width } = useWindowSize();
	const [clicked, setClicked] = useState(false);
	const [showLinks, setShowLinks] = useState(false);
	const linksContainerRef = useRef(null);
	const linksRef = useRef(null);

	const toggleLinks = () => {
		if (width < 800) {
			setShowLinks(!showLinks);
			setClicked(!clicked);
		}
	};
	useEffect(() => {
		const linksHeight = linksRef.current.getBoundingClientRect().height;
		if (showLinks) {
			linksContainerRef.current.style.height = `${linksHeight}px`;
		} else {
			linksContainerRef.current.style.height = '0px';
		}
	}, [showLinks]);
	return (
		<nav>
			<div className='nav-center'>
				<div className='nav-header'>
					<Logo>
						<h1>
							You <span>Move</span>{' '}
						</h1>
					</Logo>
					<div className='nav-toggle' onClick={toggleLinks}>
						{clicked ? <FaTimes /> : <FaBars />}
					</div>
				</div>
				<div className='links-container' ref={linksContainerRef}>
					<ul className='links' ref={linksRef}>
						{links.map((link) => {
							const { id, url, text } = link;
							return (
								<li key={id}>
									<Link to={url} onClick={toggleLinks}>
										{text}
									</Link>
								</li>
							);
						})}
						{user ? (
							<>
								<UserContainer>
									<FaUser />
									<h2>{user.displayName}</h2>
								</UserContainer>
								<Button
									onClick={() => {
										logout();
										history.push('/login');
									}}
								>
									Log Out
								</Button>
							</>
						) : (
							<Link to='/login'>
								<Button>Log In</Button>
							</Link>
						)}
					</ul>
				</div>
			</div>
		</nav>
	);
};

export default Navbar;

const Button = styled.button`
	margin-left: 20px;
	padding: 8px 20px;
	border: none;
	outline: none;
	cursor: pointer;
	border-radius: 4px;
	background: #ff6e40;
	color: #fff;
	@media screen and (max-width: 800px) {
		margin: 10px;
	}
`;

const Logo = styled.div`
	h1 {
		font-size: 1.5rem;
		font-weight: 600;
	}
	span {
		color: #ff6e40;
	}
`;

const UserContainer = styled.div`
	margin-left: 10px;
	display: flex;
	align-items: center;
	font-size: 1.2rem;

	h2 {
		margin-left: 5px;
	}
`;
